import React, { PropsWithChildren, useMemo } from 'react';

type CSVLinkProps = {
  data: string[][];
  fileName?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const CSVLink = ({
  data,
  fileName,
  className,
  children,
  style = {},
}: PropsWithChildren<CSVLinkProps>) => {
  const csvURI = useMemo(() => {
    const type = 'text/csv';
    const charset = 'utf-8';
    const cellSeparator = ',';
    const rowSeparator = '\r\n';

    const dataParsed = data.reduce((acc, row) => {
      const rowParsed = row.join(cellSeparator);

      return `${acc}${rowParsed}${rowSeparator}`;
    }, `data:${type};charset=${charset},`);

    return encodeURI(dataParsed);
  }, [data]);

  return (
    <a
      className={`wk-csv-link ${className}`}
      href={csvURI}
      download={fileName}
      style={style}
    >
      {children}
    </a>
  );
};
